import { render } from "./CWidgetDropdown.vue?vue&type=template&id=0e58d486"
import script from "./CWidgetDropdown.vue?vue&type=script&lang=js"
export * from "./CWidgetDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__